/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Scene_Change_Detection_Cannot_Scan_StatusInputs */



/**
* | output |
* | --- |
* | "Cannot scan video: {error}" |
*
* @param {Scene_Change_Detection_Cannot_Scan_StatusInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_cannot_scan_status = /** @type {((inputs: Scene_Change_Detection_Cannot_Scan_StatusInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Cannot_Scan_StatusInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Impossible d'analyser la video : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Video konnte nicht gescannt werden: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Impossibile scansionare il video: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Не удалось отсканировать видео: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`No se puede escanear el vídeo: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`无法扫描视频：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`ビデオをスキャンできません: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`वीडियो स्कैन नहीं किया जा सकता: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Não foi possível digitalizar o vídeo: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Cannot scan video: ${i?.error}`)
});